module.exports = __webpack_public_path__ + "img/items-grid-06.5b8f039b.png";